// extracted by mini-css-extract-plugin
export default {"root":"CheckBox_root__3_3Fq","centered":"CheckBox_centered__1wzp3","input":"CheckBox_input__kJ8EW","label":"CheckBox_label__Y_G6N"};